const createCompositionTableDict = (compositionJson) => {
    const sections = compositionJson.section || [];
    let compositionTableDict = { "Labels": {}, "Data": {} }
    let tableIndex = {};
    for (const section of sections) {
        if (section.code?.coding?.[0]?.code?.toLowerCase() === "column-headers") {
            for (const subsection of section.section) {
                let label;
                if (subsection.entry) {
                    for (const entry of subsection.entry) {
                        if (entry.display?.startsWith('Label for content: ')) {
                            label = entry.display.replace('Label for content: ', '');
                        }
                    }
                } else {
                    label = subsection.text?.div;
                }
                compositionTableDict["Labels"][label] = label;
                tableIndex[label] = JSON.stringify(subsection.code);
            }
        } else if ((section.code) &&
            ((section.code.coding?.[0]?.code &&
                (section.code.coding[0].code === "table-row-entry" ||
                    section.code.coding[0].code === "summary-of-findings-entry-for-a-single-outcome" ||
                    section.code.coding[0].code === "summary-of-net-effect-contributions-entry-for-a-single-outcome"
                )
            ) ||
                section.code.text === "Summary of findings entry for a single outcome" ||
                section.code.text === "Summary of net effect contributions entry for a single outcome"
            )
        ) {
            let sectionTitle = section.title;
            compositionTableDict["Data"][sectionTitle] = {};
            if ((section.text?.status === "additional" || section.text?.status === "generated") &&
                section.text.div) {
                compositionTableDict["Data"][sectionTitle]["REPLACEROW"] = section.text.div;
            } else {
                for (const subsection of section.section) {
                    let label;
                    let sectionCode = JSON.stringify(subsection.code);
                    for (const tableIndexLabel in tableIndex) {
                        if (tableIndex[tableIndexLabel] === sectionCode) {
                            label = tableIndexLabel;
                            compositionTableDict["Data"][sectionTitle][label] = subsection.text?.div;
                            if (!subsection.text || subsection.text.status === "empty") {
                                if (subsection.emptyReason) {
                                    let emptyReasonString = "";
                                    if (subsection.emptyReason.coding?.length > 0) {
                                        if (subsection.emptyReason.coding[0].display) {
                                            emptyReasonString = subsection.emptyReason.coding[0].display;
                                        } else if (subsection.emptyReason.coding[0].code) {
                                            emptyReasonString = subsection.emptyReason.coding[0].code;
                                        }
                                    }
                                    if (subsection.emptyReason.text) {
                                        emptyReasonString += " " + subsection.emptyReason.text;
                                    }
                                    if (emptyReasonString) {
                                        compositionTableDict["Data"][sectionTitle][label] = "NO DATA: " + emptyReasonString;
                                    }
                                } else {
                                    compositionTableDict["Data"][sectionTitle][label] = "<div xmlns=\"http://www.w3.org/1999/xhtml\"><div style=\"color: #AAAAAA;\">[No summary statement.]</div></div>";
                                }
                            }
                            break;
                        }
                    }
                }
            }
        } else if (section.code?.coding && section.code?.coding[0].code &&
            section.code?.coding[0].code.toLowerCase() === "summary-of-findings" &&
            Array.isArray(section.section) && section.section.length > 0) {
            for (const findingSection of section.section) {
                let sectionTitle = findingSection.title;
                compositionTableDict["Data"][sectionTitle] = {};
                if ((findingSection.text?.status === "additional" ||
                    findingSection.text?.status === "generated") &&
                    findingSection.text.div) {
                    compositionTableDict["Data"][sectionTitle]["REPLACEROW"] = findingSection.text.div;
                } else if (Array.isArray(findingSection.section)) {
                    for (const subsection of findingSection.section) {
                        let label;
                        let sectionCode = JSON.stringify(subsection.code);
                        for (const tableIndexLabel in tableIndex) {
                            if (tableIndex[tableIndexLabel] === sectionCode) {
                                label = tableIndexLabel;
                                compositionTableDict["Data"][sectionTitle][label] = subsection.text?.div;
                                if (!subsection.text || subsection.text.status === "empty") {
                                    if (subsection.emptyReason) {
                                        let emptyReasonString = "";
                                        if (subsection.emptyReason.coding?.length > 0) {
                                            if (subsection.emptyReason.coding[0].display) {
                                                emptyReasonString = subsection.emptyReason.coding[0].display;
                                            } else if (subsection.emptyReason.coding[0].code) {
                                                emptyReasonString = subsection.emptyReason.coding[0].code;
                                            }
                                        }
                                        if (subsection.emptyReason.text) {
                                            emptyReasonString += " " + subsection.emptyReason.text;
                                        }
                                        if (emptyReasonString) {
                                            compositionTableDict["Data"][sectionTitle][label] = "NO DATA: " + emptyReasonString;
                                        }
                                    } else {
                                        compositionTableDict["Data"][sectionTitle][label] = "<div xmlns=\"http://www.w3.org/1999/xhtml\"><div style=\"color: #AAAAAA;\">[No summary statement.]</div></div>";
                                    }
                                }
                                break;
                            }
                        }
                    }
                }
            }
        }
    }
    return compositionTableDict;
};

export default createCompositionTableDict;